import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addClosedcandidate,
  getClosedcandidates,
  getClosedcandidate,
  editClosedcandidate,
  deleteClosedcandidate,
  getAllClosedcandidates,
} from "../../store/actions/closedcandidate_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllClosedcandidates = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.closedcandidate);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteClosedcandidate(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getClosedcandidates({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleClosedcandidate = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.closedcandidate);
  useEffect(() => {
    dispatch(getClosedcandidate(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateClosedcandidate = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.closedcandidate);
  const addData = async (data) => {
    await dispatch(addClosedcandidate(data));
  };
  return [data, addData];
};
export const useUpdateClosedcandidate = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.closedcandidate);
  const updateData = async (id, data) => {
    await dispatch(editClosedcandidate(id, data));
  };
  return [updateData];
};

export const useSelectAllClosedcandidate = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.closedcandidate);
  useEffect(() => {
    dispatch(getAllClosedcandidates({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

 
  return [dropdownOptions
    // setClientSearchField, setClientSearchValue
  ];
};